import { Brick, Predicate, Query, registerBrick, WorkflowObjectState, Transaction } from 'olympe';
import { getLogger } from '@olympeio/core';
import BCP from './DM_BCP.js';
import { BCP_WORKFLOW_STATES } from './BcpWorkflowAuthorizations';
import { executeLambda } from "../../node/BackendData/LambdaExecutor";
import {
    generateAGQAEmailContents
} from "../BCP_QA_Notification/BCPQAEmailTemplate.js";
import { sleep } from "../utils/CommonUtil.js"


export default class BuildBCPQAEmail extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} sendEmail
     * @param {function()} forwardEvent
     */
    async update($, [sendEmail], [forwardEvent]) {
        getLogger('BuildBCPQAEmail').info(`BuildBCPQAEmail - Started at ${new Date(Date.now()).toISOString()}`); 

        try {
            // CTAG email starts
            getLogger('BuildBCPQAEmail').info(`BuildBCPQAEmail - Started CTAG at ${new Date(Date.now()).toISOString()}`); 

            let queryCTAG = Query.instancesOf(BCP).andReturn()
                .follow(WorkflowObjectState.currentObjectRel.getInverse())
                .filter(Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE)).andReturn();
            await queryCTAG.execute().then(async (queryResult) => {
                let CTAGResult = queryResult.toArray();
                //getLogger('Build BCP CTAG List').info("CTAG query result array", CTAGResult)

                let BCPGroupbyCtag = [];

                if (CTAGResult?.length > 0) {
                    for (const [bcp, workflowObject] of CTAGResult) {
                        //getLogger('Workflow data').info("state 1:", workflowObject.get(WorkflowObjectState.stateProp), BCP_WORKFLOW_STATES);
                        //getLogger('Workflow data').info("BCP notification stage:", bcp.get(BCP.notification_stageProp));
                        if ((bcp.get(BCP.notification_stageProp) !== BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE
                            && bcp.get(BCP.notification_stageProp) !== BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1
                            && bcp.get(BCP.notification_stageProp) !== BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2)
                            || bcp.get(BCP.notification_stageProp) === null) {
                            getLogger('Name of CTAG').info("bcp object and CTAG:", bcp, bcp.get(BCP?.technicalApplicationGroupProp));
                            let ctagProp = bcp.get(BCP?.technicalApplicationGroupProp)
                            if (!BCPGroupbyCtag[ctagProp]) {
                                BCPGroupbyCtag[ctagProp] = [];
                            }

                            // Grouping
                            let actualBCPObject = [bcp, workflowObject];
                            BCPGroupbyCtag[ctagProp].push({
                                actualBCPObject
                            });
                        }
                    }
                }
                if (Object.entries(BCPGroupbyCtag).length > 0) {
                    let indexA = 0;
                    for (const [key, value] of Object.entries(BCPGroupbyCtag)) {
                        indexA++;
                        //getLogger('Workflow data').info("state CTAG:", key, value,indexA);
                        const emailOfUser = key.split(/[:;]/)[1]
                        const nameOfUser = key.split(/[:;]/)[0]
                        const partner = "CTAG/AG"
                        const statement = "Please accept/reject the BCP request as per alignment with procurement BP. To accept the BCP request, please include the date of completion of Local acceptance."
                        //getLogger('Name of CTAG').info("details :", emailOfUser, nameOfUser)
                        let emailBody = await generateAGQAEmailContents(nameOfUser, value, partner, statement, $)
                        //getLogger('Details of BCP Object CTAG').info("Ctag details :", value[0].actualBCPObject)
                        const t = new Transaction(true);
                        value?.forEach((bcp) => {
                            BCP.setNotification_stage(t, bcp.actualBCPObject[0], BCP_WORKFLOW_STATES?.CTAG_ACCEPTANCE);
                        })
                        t.execute().then(async () => {
                            try {
                                if ((indexA + 1) % 100 === 0) {
                                    await sleep(2000);
                                }
                                getLogger('BuildBCPQAEmail').info(`Before sending CTAG email to ${emailOfUser}`);

                                await executeLambda($, sendEmail, [emailOfUser, "BCP request - CTAG/AG notification", emailBody]);

                                getLogger('BuildBCPQAEmail').info(`BuildBCPQAEmail - Sent CTAG Email to ${emailOfUser}`); 
                            } catch (error) {
                                // Handle errors during the send email process here
                                getLogger('BuildBCPQAEmail').error(`0193d99a8e8cda2cc428: error sending BCP QA email for CTAG:${emailOfUser} with reason : ${error.message}`);
                            }
                        }).catch((reason) => {
                            getLogger('BuildBCPQAEmail').error(`0193d99a8e8cda2cc428: could not update notification prop for BCP request: ${reason}`);
                        })
                    }
                }
            })

            getLogger('BuildBCPQAEmail').info(`BuildBCPQAEmail - Completed CTAG at ${new Date(Date.now()).toISOString()}`); 
            // CTAG email ends

            // 10-seconds pause
            await new Promise(resolve => setTimeout(resolve, 10000));

            // QA1/QA2 email starts
            let queryQA1OrQA2 = Query.instancesOf(BCP).andReturn()
                .follow(WorkflowObjectState.currentObjectRel.getInverse())
                .filter(
                    Predicate.or(
                        Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1),
                        Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2)
                    ))
                .andReturn();
            //getLogger('Build BCP QA1/QA2 list').info("query of QA1 Or QA2: ", queryQA1OrQA2);
            await queryQA1OrQA2.execute().then(async (queryResult) => {
                let QA1AndQA2Result = queryResult.toArray();
                //getLogger('Build BCP QA1/QA2 list').info("QA1 And QA2 Result: ", QA1AndQA2Result);
                let BCPGroupbyQA1 = [];
                let BCPGroupbyQA2 = [];
                let qa2FullName = "";
                if (QA1AndQA2Result?.length > 0) {
                    for (const [bcp, workflowObject] of QA1AndQA2Result) {
                        //getLogger('Workflow data').info("QA1 and QA2 state", workflowObject.get(WorkflowObjectState.stateProp));
                        //getLogger('Workflow data').info("BCP notification stage:", bcp.get(BCP.notification_stageProp));
                        if ((bcp.get(BCP.notification_stageProp) === BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE
                            || bcp.get(BCP.notification_stageProp) === BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM
                            || bcp.get(BCP.notification_stageProp) === BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP
                            || bcp.get(BCP.notification_stageProp) === null || bcp.get(BCP.notification_stageProp) === "")
                            && bcp.get(BCP.notification_stageProp) !== BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1
                            && bcp.get(BCP.notification_stageProp) !== BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2) {
                            //getLogger('Name of QA1 and QA2').info("details :", bcp, bcp.get(BCP.qualityAssuranceProp), bcp.get(BCP.qaInFactoryProp));
                            let qualityAssuranceProp = bcp.get(BCP.qualityAssuranceProp)
                            let qaInFactoryProp = bcp.get(BCP.qaInFactoryProp)
                            qa2FullName = qualityAssuranceProp?.split(/[:;]/)[0]
                            if (!BCPGroupbyQA1[qualityAssuranceProp]) {
                                BCPGroupbyQA1[qualityAssuranceProp] = [];
                            }

                            if (!BCPGroupbyQA2[qaInFactoryProp]) {
                                BCPGroupbyQA2[qaInFactoryProp] = [];
                            }
                            // Grouping the BCPs based on userIds for QA1 / QA2
                            let actualBCPObject = [bcp, workflowObject];

                            BCPGroupbyQA1[qualityAssuranceProp].push({
                                actualBCPObject
                            });

                            // adding data for QA in Factory
                            BCPGroupbyQA2[qaInFactoryProp].push({
                                actualBCPObject
                            });
                        }
                    }
                }

                getLogger('BuildBCPQAEmail').info(`BuildBCPQAEmail - Started QA1/SQA at ${new Date(Date.now()).toISOString()}`); 
                if (Object.entries(BCPGroupbyQA1).length > 0) {
                    let indexA = 0;
                    for (const [key, value] of Object.entries(BCPGroupbyQA1)) {
                        indexA++;
                        //getLogger('Key and Value').info("key, value :", key, value)
                        const emailOfUser = key.split(/[:;]/)[1]
                        const nameOfUser = key.split(/[:;]/)[0]
                        const partner = "SQA"
                        const statement = "Check if there is a need for an audit to be done for the BCP request. If yes, then please accept the BCP request and include the target date of completion of the audit. If there is no need for an audit, then please accept the BCP request and select the next day as the completion date."
                        //getLogger('Name of QA1 and QA2').info("details :", emailOfUser, nameOfUser)
                        let emailBody = await generateAGQAEmailContents(nameOfUser, value, partner, statement, $)

                        getLogger('BuildBCPQAEmail').info("BuildBCPQAEmail - QA1 Email body", emailBody);

                        const t = new Transaction(true);
                        //getLogger('Value of BCP QA1').info("BCP value :", value[0].actualBCPObject[0])


                        await t.execute()
                            .catch((reason) => {
                                console.error(`0193d99a8e8cda2cc428: could not update notification prop for BCP request: ${reason}`);
                            })
                        try {
                            if ((indexA + 1) % 100 === 0) {
                                await sleep(2000);
                            }
                            getLogger('BuildBCPQAEmail').info("Before sending QA1 email to ", emailOfUser);

                            await executeLambda($, sendEmail, [emailOfUser, "BCP request - SQA notification", emailBody]);
                            
                            value?.forEach((bcp) => {
                                BCP.setNotification_stage(t, bcp.actualBCPObject[0], BCP_WORKFLOW_STATES?.QA_FACTORY_ACCEPTANCE_1);
                            })

                            getLogger('BuildBCPQAEmail').info(`BuildBCPQAEmail - Sent QA1/SQA Email to ${emailOfUser}`);
                        } catch (error) {
                            // Handle errors during the send email process
                            throw new Error(`Error in sending BCP QA email for QA in Factory:${emailOfUser}`);
                        }
                    }
                }
                getLogger('BuildBCPQAEmail').info(`BuildBCPQAEmail - Completed QA1/SQA at ${new Date(Date.now()).toISOString()}`);               

                // 10-seconds pause
                await new Promise(resolve => setTimeout(resolve, 10000));

                getLogger('BuildBCPQAEmail').info(`BuildBCPQAEmail - Started QA2 at ${new Date(Date.now()).toISOString()}`); 

                // send email for QA In factory
                if (Object.entries(BCPGroupbyQA2).length > 0) {
                    let indexA = 0;
                    for (const [key, value] of Object.entries(BCPGroupbyQA2)) {
                        indexA++;
                        //getLogger('Value of BCP QA2').info("bcp value :", value, value[0].actualBCPObject[0])
                        const nameOfUser = key.split(/[:;]/)[0]
                        const emailOfUser = key.split(/[:;]/)[1]
                        const partner = "QA in factory"
                        const statement = "Perform trials/test (if applicable), ensure local acceptance & vendor audit has been completed successfully. If yes, then accept the BCP request and include date when QIR will be created. If no, then reject BCP request."
                        let emailBody = await generateAGQAEmailContents(nameOfUser, value, partner, statement, $)
                        
                        //getLogger('BuildBCPQAEmail').info("BuildBCPQAEmail - QA2 Email body", emailBody);
                        
                        const t = new Transaction(true);
                        value?.forEach((bcp) => {
                            BCP.setNotification_stage(t, bcp.actualBCPObject[0], BCP_WORKFLOW_STATES?.QA_FACTORY_ACCEPTANCE_2);
                        })
                        await t.execute()
                            .catch((reason) => {
                                console.error(`0193d99a8e8cda2cc428: could not update notification prop for BCP request: ${reason}`);
                            })
                                                
                            try {
                            if ((indexA + 1) % 100 === 0) {
                                await sleep(2000);
                            }
                            getLogger('BuildBCPQAEmail').info(`BuildBCPQAEmail - Before sending QA2 email to ${emailOfUser}`);
                            
                            await executeLambda($, sendEmail, [emailOfUser, "BCP request - QA in Factory notification", emailBody]);

                            getLogger('BuildBCPQAEmail').info(`BuildBCPQAEmail - Sent QA2 Email to ${emailOfUser}`);
                        } catch (error) {
                            // Handle errors during the send email process
                            throw new Error(`Error in sending BCP QA email for SQA:${emailOfUser}`);
                        }
                    }
                }

                getLogger('BuildBCPQAEmail').info(`BuildBCPQAEmail - Completed QA2 at ${new Date(Date.now()).toISOString()}`);
            })

            getLogger('BuildBCPQAEmail').info(`BuildBCPQAEmail - Completed at ${new Date(Date.now()).toISOString()}`);
        }
        // QA1/QA2 email ends
        catch (error) {
            getLogger('BuildBCPQAEmail').error(`0193d99a8e8cda2cc428: Could not send email for the error: ${error}`);
        }
        finally {
            forwardEvent();
        }
    }
}

registerBrick('0193d99a8e8cda2cc428', BuildBCPQAEmail);
